// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"3dac39bf","410":"ef1ab89a"}[chunkId] + ".chunk.css";
};